import { Injectable } from '@angular/core';
import { BookWidgetFieldUpdateEvent } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Store } from '@ngrx/store';
import * as fromBookWidgetActions from '../+state/actions/book-widget.actions';
import * as fromBookWidgetSelectors from '../+state/selectors/book-widget.selectors';
import { FlightShopWidgetTemplates } from '../constants/flight-shop.constants';

@Injectable({
  providedIn: 'root'
})
export class BookWidgetFacade {
  isBookWidgetReady$ = this.store.select(
    fromBookWidgetSelectors.isBookWidgetReady
  );

  bookWidgetFields$ = this.store.select(
    fromBookWidgetSelectors.getBookWidgetFields
  );

  guidedNavigationErrorMsg$ = this.store.select(
    fromBookWidgetSelectors.getGuidedNavigationErrorMsg
  );

  constructor(private store: Store) {}

  setFlightShopTemplateType(templateType: FlightShopWidgetTemplates) {
    this.store.dispatch(
      fromBookWidgetActions.SetFlightShopTemplateType({ templateType })
    );
  }

  triggerInitFields() {
    this.store.dispatch(fromBookWidgetActions.TriggerInitFields());
  }

  bookWidgetFieldChangeHandler(
    bookWidgetFieldUpdateEvent: BookWidgetFieldUpdateEvent
  ) {
    this.store.dispatch(
      fromBookWidgetActions.BookWidgetFieldChange({
        bookWidgetFieldUpdateEvent
      })
    );
  }

  swapAirportsHandler(flightIndex: number) {
    this.store.dispatch(fromBookWidgetActions.SwapAirports({ flightIndex }));
  }

  addFlightsForMcHandler() {
    this.store.dispatch(fromBookWidgetActions.AddFlightsForMc());
  }

  removeFlightForMcHandler() {
    this.store.dispatch(fromBookWidgetActions.RemoveFlightForMc());
  }

  findFlightInitiated() {
    this.store.dispatch(fromBookWidgetActions.FindFlightInitiated());
  }
}
